import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { pushModal } from 'loot-core/client/actions';

import { useNavigate } from '../hooks/useNavigate';

export function BillingThankYou() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const productId = searchParams.get('productId');
    const selectedBillingInterval = searchParams.get('billingInterval');
    const isPostBillingSetup = searchParams.get('post-billing-setup');
    if (isPostBillingSetup !== '1' && !productId && !selectedBillingInterval) {
      return;
    }

    dispatch(
      pushModal('confirm-generic', {
        title: 'Subscription Confirmed! 🎉',
        text: `Thank you for subscribing! ${productId && selectedBillingInterval ? 'Your subscription is now active and the payment method has been successfully updated.' : 'With your subscriptions now active, you have unlocked premium features such as Device Sync and Bank Sync.'} Congratulations!<br/><br/> If you have any questions or need any assistance, please feel free to reach out to our <a href="mailto:support@goodsteward.io">support team</a>. Welcome aboard!`,
        hideCancelButton: true,
        confirmBtnText: 'Close',
        onConfirm: () => {
          !productId && !selectedBillingInterval && navigate('/accounts');
        },
      }),
    );
  }, []);

  return <></>;
}
